import { Answer, Field } from 'store/states/forms/types';
import { FieldBoxWithImage } from './FieldBoxWithImage';
import { FieldBox } from './FieldBox';
import { FieldBoxWithSubfields } from './FieldBoxWithSubfields';

interface IFieldBox {
  field: Field;
  answer: Answer;
  index?: number;
  handleEdit: () => void;
  // Histórico: exibe no máximo uma quebra de linha por vez
  isHistoric?: boolean;
}

export function FieldBoxComponent({
  field,
  answer,
  index,
  handleEdit,
  isHistoric,
}: IFieldBox) {
  if (field?.type === 'checkbox' && answer?.value) {
    const multiAnswers =
      typeof answer.value === 'string' ? answer.value.split('\t').slice(1) : [];

    const formatedAnswer = multiAnswers
      .map(
        (multiAnswer) =>
          field.items?.find(
            (item) => (item.value as unknown as string) === multiAnswer,
          )?.label ?? multiAnswer,
      )
      .join('; ');

    return (
      <FieldBox
        field={field}
        answer={{ field_id: answer.field_id, value: formatedAnswer }}
        index={index}
        handleClickEdit={handleEdit}
        isHistoric={isHistoric}
      />
    );
  }
  switch (field.type) {
    case 'signature':
      return (
        <FieldBoxWithImage
          field={field}
          answer={answer}
          index={index}
          handleClickEdit={handleEdit}
        />
      );
    case 'draw':
      return (
        <FieldBoxWithImage
          field={field}
          answer={answer}
          index={index}
          handleClickEdit={handleEdit}
        />
      );
    case 'image':
      return (
        <FieldBoxWithImage
          field={field}
          answer={answer}
          index={index}
          handleClickEdit={handleEdit}
        />
      );
    case 'checkbox_group': {
      let valueSubfield: any = answer?.value ?? [];

      if (typeof valueSubfield === 'string' && valueSubfield.trim() !== '') {
        try {
          valueSubfield = JSON.parse(valueSubfield);
        } catch {
          valueSubfield = [];
        }
      }

      return (
        <FieldBoxWithSubfields
          field={field}
          answer={{ ...answer, value: valueSubfield }}
          index={index}
          handleClickEdit={handleEdit}
          isHistoric={isHistoric}
        />
      );
    }

    default:
      return (
        <FieldBox
          field={field}
          answer={answer}
          index={index}
          handleClickEdit={handleEdit}
          isHistoric={isHistoric}
        />
      );
  }
}
